import { debounce } from "lodash";
import { useState } from "react";
import { useDeleteScheduledMessage } from "../../../App/Queries/MessageQueries";
import { IGroupMessageView } from "../../../App/Typings/MessageText";
import { ITableColumn } from "../../../App/Typings/TableColumn";

export default function ScheduledMessageDialogState() {
  const defaultMsg: IGroupMessageView = {
    create: new Date(),
    messageDisplay: "",
    messageTextId: "",
    messageTrackingId: "",
    scheduledTimeEaster: "",
    userName: "",
    type: "",
    messageState: "",
    userId: "",
    recipient: "",
    recipientId: "",
  };

  const columnNames: ITableColumn[] = [
    { label: "Candidate", propName: "recipient", order: 0 },
    { label: "Type", propName: "type", order: 1 },
    { label: "State", propName: "messageState", order: 2 },
    { label: "Scheduled", propName: "scheduledUtcTime", order: 3 },
    { label: "Message", propName: "messageDisplay", order: 4 },
    { label: "Actions", propName: "actions", order: 5 },
  ];
  const [showScheduledMessageDialog, setShowScheduledMessageDialog] = useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [schMessages, setScheduledMessages] = useState<IGroupMessageView[]>([]);
  const { mutate: deleteScheduledMessage, isLoading: deleteScheduledMessageIsLoading } =
    useDeleteScheduledMessage();
  const [actionMessage, setActionMessage] = useState<IGroupMessageView>(defaultMsg);
  const handleClose = () => {
    setShowScheduledMessageDialog(false);
  };
  const handleSave = () => {
    setShowScheduledMessageDialog(false);
  };
  const handleConfirmationResponse = (msg: IGroupMessageView, response: boolean) => {
    if (response) {
      const filterList = schMessages.filter((list) => {
        return msg !== list;
      });
      setScheduledMessages(filterList);
      handleConfirmDeleteSelectedScheduledMessages(msg);
    }
    setShowConfirmDialog(false);
  };

  const handleConfirmDeleteSelectedScheduledMessages = debounce((msg: IGroupMessageView) => {
    const filterList = schMessages.filter((list) => {
      return msg !== list;
    });

    deleteScheduledMessage(msg.messageTrackingId, {
      onSuccess: () => {
        setScheduledMessages(filterList);
      },
    });
  }, 300);

  const deleteSelectedScheduledMessages = (msg: IGroupMessageView) => {
    setActionMessage(msg);
    setShowConfirmDialog(true);
  };

  return {
    getters: {
      showScheduledMessageDialog,
      columnNames,
      schMessages,
      showConfirmDialog,
      actionMessage,
      deleteScheduledMessageIsLoading,
    },
    setters: {
      setShowScheduledMessageDialog,
      setScheduledMessages,
      setShowConfirmDialog,
      setActionMessage,
    },
    handlers: {
      handleClose,
      handleSave,
      deleteSelectedScheduledMessages,
      handleConfirmationResponse,
    },
  };
}
